<template>
  <div>
    <div dir="rtl">
      <BaseInput v-model="staged_tag.name" label="שם :" />
    </div>
    <div class="modal_footer">
      <a
        @click="submit(true)"
        :class="{ 'is-loading': is_submitting }"
        class="button is-info is-rounded"
        >הזן ורענן לי את הדף</a
      >
      <a
        @click="submit(false)"
        :class="{ 'is-loading': is_submitting }"
        class="button is-info is-rounded"
        style="margin: 10px"
        >הזן ואל תרענן</a
      >
    </div>
  </div>
</template>
<script>
// libraries
import { mapActions } from 'vuex'

// components
import BaseInput from '@/components/BaseInput'

// constants
import { STORE_NAMESPACE, FETCH_ALL } from '@/store/modules/tag_list/types'

export default {
  name: 'tag-list-form',
  props: ['payload'],
  data () {
    return {
      staged_tag: {},
      blank_tag: {
        name: ''
      },
      is_submitting: false,
      is_refresh: false
    }
  },
  async created () {
    this.staged_tag = { ...this.blank_tag }
    if (!this.payload.is_create) {
      try {
        const r = await this.$network_utils.getTag({
          id: this.payload.data.id
        })
        this.staged_tag = r
      } catch (e) {
        console.log(e)
      }
    }
  },
  methods: {
    ...mapActions(STORE_NAMESPACE, [FETCH_ALL]),
    async create_data () {
      try {
        const r = await this.$network_utils.postTag(this.staged_tag)
        if (this.refresh) {
          this[FETCH_ALL]()
        }
        this.$utils.emit('show_toast', {
          text: `Success: You successfully created the following tag: ${r.name}`
        })
        this.staged_tag = { ...this.blank_tag }
      } catch (e) {
        this.$utils.emit('show_toast', { text: `Error: try again` })
        console.error(e)
      }
    },
    async update_data () {
      try {
        const r = await this.$network_utils.updateTag(this.staged_tag)
        if (this.refresh) {
          this[FETCH_ALL]()
        }
        this.$utils.emit('show_toast', {
          text: `Success: You successfully updated the following tag: ${r.name}`
        })
      } catch (e) {
        this.$utils.emit('show_toast', { text: `Error: try again` })
        console.error(e)
      }
    },
    submit (refresh) {
      this.refresh = refresh
      if (this.payload.is_create) {
        this.create_data(refresh)
      } else {
        this.update_data(refresh)
      }
    }
  },
  components: {
    BaseInput
  }
}
</script>
